import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Comment18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.25 2.5C0.25 1.80964 0.809644 1.25 1.5 1.25H16.5C17.1904 1.25 17.75 1.80964 17.75 2.5V13.5C17.75 14.1904 17.1904 14.75 16.5 14.75H8.31066L5.88388 17.1768C5.09643 17.9642 3.75 17.4065 3.75 16.2929V14.75H1.5C0.809644 14.75 0.25 14.1904 0.25 13.5V2.5ZM1.75 2.75V13.25H5.25V15.6893L7.68934 13.25H16.25V2.75H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Comment18.displayName = 'Comment18';
export default Comment18;
